import React from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import ls from 'local-storage';
import API from "../../../Services/BaseService";
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import { Button } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import adduser from '../../../assets/img/adduser.jpg'
import Loading from "../../../Component/Loading/Loading";
import PageNotFound from '../../FallBackUI/PageNotFound';
import DealerAction from '../../DealerRedux/DealerAction';
import _ from 'lodash';
import CustomPagination from '../../CustomPagination/CustomPagination';

const Seller = () => {
    const pageLimit = 10;
    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    // let userDetails = ls.get('userDetails');
    const [userList, setUserList] = useState("");
    const [sellerReqId, setSellerreqId] = useState("");
    const [data, setData] = useState("");
    const [name, setName] = useState("");
    const [Status, setStatus] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [oldUserList, setOldUserList] = useState("");
    const [privilegeDetails, setPrivilegeDetails] = useState("");
    const dealerData = useSelector(state => state.DealerReducer.payload);
    const [dealerList, setDealerList] = useState("");
    const [dealerId, setDealerId] = useState("");
    const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
    const [selectSellerId, setselectSellerid] = useState("");
    console.log("selectSellerId", selectSellerId)
    const [flagFilter, setFalgFilter] = useState(false);


    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);

    //pagination
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchFlag, setSearchFlag] = useState(false);
    const [searchFlag1, setSearchFlag1] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    console.log(totalPages, "totalPages");
    console.log(totalRecords, "totalReco");

    const handlePages = (page) => {
        ls.set("currentpageopen", page)
        setCurrentPage(page)
        setSearchFlag1(true)
    }

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setSearchFlag1(true)
    };

    const [carSearchTriggered, setCarSearchTriggered] = useState(false);
    console.log("rocords carSearchTriggered", carSearchTriggered, searchFlag1, searchFlag);

    const handlePageChangeDebounced = _.debounce(() => {
        if (!searchFlag1 && !searchFlag) {
            getuserDetails(dealerData);
        }
        else if (searchFlag1 && searchFlag && !carSearchTriggered) {
            searchSeller(dealerData);
        } else if (searchFlag1 && !searchFlag) {
            getuserDetails(dealerData);
        }
    }, 300);

    useEffect(() => {
        if (searchFlag || searchFlag1) {
            setCarSearchTriggered(false);
        }
    }, [searchFlag, searchFlag1]);




    useEffect(() => {

        handlePageChangeDebounced();
        console.log("checking if in useEffect");
        return () => {
            handlePageChangeDebounced.cancel();
        };

    }, [currentPage]);
    //pagenination end


    const getAddSellerPrivileges = () => {
        togglePopup()
        setPopupMsg("Seller doesn't have Create User Privilege");
        setPopupActionType("close");
        setPopupActionValue("ok");
    }

    useEffect(() => {
        privileges(dealerData);
    }, [dealerData]);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const successData = useSelector(state => state.LoginReducer.payload);
    console.log("=======>", successData)
    async function getuserDetails(data) {
        let request = {
            // seller_dealer_id: flagFilter == true ? selectSellerId : successData.seller_dealer_id,
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
            rowsPerPage: pageLimit,
            page: currentPage,
        };
        const state = API.post('seller_list/condition', request);
        state.then(res => {
            console.log("res", res.data.data)
            if (res.data.success === true) {
                //setLoading(false);
                setOldUserList(res.data.data);
                //setUserList(res.data.data);
                setStatus(res.data.data1)
                setSellerreqId(res.data.data[0].seller_dealer_request_id)
                console.log("setStatus", res.data.data1);
               
                let merged = res.data.data
                setUserList(merged)
                setTotalPages(Math.ceil(res.data.data3.totalCount / 10));
                setTotalRecords([...Array(Math.ceil(res.data.data3.totalCount / 10) + 1).keys()].slice(1))
                 setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }
            setLoading(false);

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
    }

    const OnSearch = (e) => {
        console.log("====on search ====", e.target.value.replace(/[^a-zA-Z\s]/g, ""))
        const newName = e.target.value.replace(/[^a-zA-Z\s,0-9]/g, "");
        setName(newName)
        // handleNameChange(e.target.value)
    }

    function searchSeller(data, val) {
        console.log("=====data=======>", data)
        let request = {
            data: name ? name : "",
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

            // seller_dealer_id: dealerData !== null ? dealerData.seller_dealer_id : successData.seller_dealer_id,
            seller_token: successData.seller_token,
            seller_id: successData.seller_id,
            rowsPerPage: pageLimit,
            page: val == 1 ? 1 : currentPage,

        }
        // if (data !== "") {
        API.post("sellerSearch/condition", request)
            .then((response) => {
                if (response.data.success === true) {
                    // setUserList(response.data.data);
                    console.log("sellerSearch", response.data.data)
                    let merged = response.data.data

                    setUserList(merged)
                    setTotalPages(Math.ceil(response.data.data3.totalCount / 10));
                    setTotalRecords([...Array(Math.ceil(response.data.data3.totalCount / 10) + 1).keys()].slice(1))

                }
                else {
                    setErrors(response.data.error)
                    setErrorFlag(true)
                    console.log("errors123", errors);

                }
                setLoading(false);
            },)
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
        // } 
        // else {
        //     setUserList(oldUserList);

        // }
    }

    // function searchSeller() {
    //     console.log("=====data=======>", data)
    //     let request = {
    //         data: data,
    //         seller_dealer_id: successData.seller_dealer_id,
    //         seller_token: successData.seller_token,
    //         seller_id: successData.seller_id,

    //     }
    //     if (data !== "") {
    //         API.post("sellerSearch/condition", request)
    //             .then((response) => {
    //                 if (response.data?.data?.length == 0) {
    //                     setUserList(oldUserList);
    //                     togglePopup()
    //                     setPopupTitle("Data not found ");
    //                     setPopupType("error");
    //                     setPopupActionType("close");
    //                     setPopupActionValue("ok");

    //                 }
    //                 else if (response.data.data.length !== 0) {
    //                     console.log("=====response=======>", response)
    //                     console.log("rep search req", request);
    //                     console.log("inside rep search", response.data.data);
    //                     setUserList(response.data.data);
    //                 }

    //             },
    //                 (error) => {
    //                     console.log(error);
    //                 }
    //             );
    //     } else {
    //         setUserList(oldUserList);

    //     }
    // }
    // function onHandleEdit(e) {
    //     history.push("/selleredit/"+e);
    //   }
    function onHandleEdit(item) {
        history.push({
            pathname: "/selleredit",
            state: { id: item.seller_id, sellerId: dealerId, sellerDealer: item.seller_dealer_id, sellerRequest: item.seller_request_id }
        });
    }
    useEffect(() => {
        getuserDetails(dealerData);
        getDealername();

    }, [dealerData]);
    function formatMobileNO(value) {
        var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
        console.log("value of x", x);
        value = '(' + x[1] + ') ' + x[2] + '-' + x[3];
        console.log("mobileno", value);
        return value;
    }
    const privileges = (data) => {
        let request = {
            seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post("sellerPrivileges/condition", request)
            .then((response) => {
                console.log("privilege", response.data.data[0])
                if (response.data.success === true) {
                    setPrivilegeDetails(response.data.data[0])
                }
                else {
                    setErrors(response.data.error)
                    setErrorFlag(true)
                }
            })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const handleSellerDetailsName = (e) => {

        setDealerId(e.target.value)
        console.log("=========check seller details name", e.target.value)
        setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
        console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value))
        const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
        getfileterSellerList(selectedSellerDetails);
        setselectSellerid(selectedSellerDetails.seller_dealer_id)
        setFalgFilter(true)
        dispatch(DealerAction.searchrequest(selectedSellerDetails));
    }


    useEffect(() => {
        if (dealerData !== null) {

            getfileterSellerList(dealerData);
        }
    }, [dealerData])

    const getDealername = (data) => {

        let request = {
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post("dealerNameDynamic/condition", request).then(response => {
            if (response.data.success === true) {


                setDealerList(response.data.data);

            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }


        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    const getfileterSellerList = (data) => {

        let request = {
            seller_dealer_id: data.seller_dealer_id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token
        }
        API.post("seller_listFilter/condition", request).then(response => {
            if (response.data.success === true) {
                setUserList(response.data.data);

            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }
    const MaskedSSN = (ssn) => {
        const lastFourDigits = ssn.slice(-4);
        const maskedSSN = '*****' + lastFourDigits;
        return maskedSSN;
    };
    return (
        <div>
            {loading ? <Loading /> :
                <main id="main" className="inner-page">
                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <section class="section" >
                            <div id='ManageSeller'>
                                <div class="container-fluid inner-page-space">
                                    <div class="common-heading mb-2">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div class="back-btn">
                                                    <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                                                        <i class="bx bx-chevron-left"></i> Back
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title">
                                                    <p class="inner-title">Sellers</p>
                                                </div>
                                            </div>

                                            <div className="col-lg-4">
                                                <div class="title-dropdown">
                                                    <select id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
                                                        ? "tableRowPink  form-control box"
                                                        : dealerData?.color == "firered"
                                                            ? "tableRowFireRed  form-control box"
                                                            : dealerData?.color == "green"
                                                                ? "tableRowGreenColor form-control box"
                                                                : dealerData?.color == "darkred"
                                                                    ? "tableRowRed1  form-control box"
                                                                    : " form-control box") :
                                                        (dealerList[0]?.color == "pink"
                                                            ? "tableRowPink  form-control box"
                                                            : dealerList[0]?.color == "firered"
                                                                ? "tableRowFireRed  form-control box"
                                                                : dealerList[0]?.color == "green"
                                                                    ? "tableRowGreenColor form-control box"
                                                                    : dealerList[0]?.color == "darkred"
                                                                        ? "tableRowRed1  form-control box"
                                                                        : " form-control box")
                                                        }`} onChange={handleSellerDetailsName}>
                                                        {dealerData != null ?
                                                            <option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
                                                            <option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}
                                                        {dealerList.length > 0 &&
                                                            <>
                                                                {dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
                                                                    ? "tableRowPink  user_name"
                                                                    : dealerList?.color == "Silver"
                                                                        ? "tableRowSilver  user_name"
                                                                        : dealerList?.color == "Orange"
                                                                            ? "tableRowOrange  user_name"
                                                                            : dealerList?.color == "Navy blue"
                                                                                ? "tableRowNavyBlue  user_name"
                                                                                : dealerList?.color == "firered"
                                                                                    ? "tableRowFireRed  user_name"
                                                                                    : dealerList?.color == "Purple"
                                                                                        ? "tableRowPurple  user_name"
                                                                                        : dealerList?.color == "Yellow"
                                                                                            ? "tableRowYellow1  user_name"
                                                                                            : dealerList?.color == "green"
                                                                                                ? "tableRowGreenColor user_name"
                                                                                                : dealerList?.color == "blue"
                                                                                                    ? "tableRowBlue  user_name"
                                                                                                    : dealerList?.color == "darkred"
                                                                                                        ? "tableRowRed1  user_name"
                                                                                                        : dealerList?.color == "black"
                                                                                                            ? "tableRowBlack1 user_name"
                                                                                                            : " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
                                                            </>
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12 col-sm-12 accountleftblock">
                                            <ManageAccountLinks />
                                        </div>
                                        <div className="col-lg-8 col-md-12 col-sm-12 adduserpagerightblock">
                                            <div className="adduserpage-inner">
                                                <div className="col-lg-12">
                                                    <div className='row'>
                                                        <div className=" col-lg-9" >
                                                            <div className="input-group searchbox manage-serch">
                                                                {/* <input type="text" className="form-control border" placeholder="SellerName/Phoneno/Email" onChange={(e) => setData(e.target.value)}></input> */}
                                                                <input type="text" className="form-control border" placeholder="SellerName/Phone #/Email" onChange={OnSearch} value={name}></input>
                                                                <span className="input-group-append" >
                                                                    <button className="btn ms-n5" type="button" id="btntest" name="btntest" disable /* onClick={() => searchSeller(dealerData)}  */
                                                                        onClick={() => { searchSeller(dealerData, 1); setSearchFlag(true); setCurrentPage(1) }} ><i className='bx bx-search'></i></button>
                                                                </span>

                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">

                                                            {Status == "Seller" || privilegeDetails?.create_user == 0 ? "" :
                                                                <div className="add-user">
                                                                    <Button className="add-user-btns"
                                                                        onClick={() => history.push({
                                                                            pathname: "/adduser",
                                                                            state: { flagFilter: flagFilter, selectSellerId: selectSellerId, sellerReqId: sellerReqId }
                                                                        })}

                                                         /* onClick={() => { privilegeDetails?.create_user == 0 ? getAddSellerPrivileges() : history.push("/adduser") }} */><i className="icofont-plus"></i> Add User</Button>
                                                                </div>
                                                            }


                                                            {/* <a className="add-user-btns" href="/adduser"><i className="icofont-plus"></i> Add User</a> */}
                                                        </div>
                                                    </div>


                                                    <div className="col-lg-12">
                                                        <div class="table-responsive">
                                                            <div className='Sellertabletable'>

                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="">Seller Dealer #</th>
                                                                            <th className="">Seller Dealer Name</th>
                                                                            <th className="">Seller #</th>
                                                                            <th className="">Seller Name</th>
                                                                            <th className="">Email</th>
                                                                            <th className="">Image</th>
                                                                            <th className="">Phone #</th>
                                                                            <th className="">Extension</th>
                                                                            {/* <th>Email</th> */}
                                                                            <th className="">Privileges</th>
                                                                            <th className="">Email Status</th>
                                                                            <th className="">SSN #</th>
                                                                            <th className="">Status</th>
                                                                            <th className="th_action action-right-fix-header">Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    {userList.length > 0 ? userList.map((item, index) =>
                                                                        <tr>
                                                                            <td className={item.seller_dealer_id != "" ?
                                                                                item.dealercolor == "pink"
                                                                                    ? "tableRowPink "
                                                                                    : item.dealercolor == "Silver"
                                                                                        ? "tableRowSilver "
                                                                                        : item.dealercolor == "Orange"
                                                                                            ? "tableRowOrange "
                                                                                            : item.dealercolor == "Navy blue"
                                                                                                ? "tableRowNavyBlue "
                                                                                                : item.dealercolor == "firered"
                                                                                                    ? "tableRowFireRed "
                                                                                                    : item.dealercolor == "Purple"
                                                                                                        ? "tableRowPurple "
                                                                                                        : item.dealercolor == "Yellow"
                                                                                                            ? "tableRowYellow1 "
                                                                                                            : item.dealercolor == "green"
                                                                                                                ? "tableRowGreenColor "
                                                                                                                : item.dealercolor == "blue"
                                                                                                                    ? "tableRowBlue "
                                                                                                                    : item.dealercolor == "darkred"
                                                                                                                        ? "tableRowRed1 "
                                                                                                                        : item.dealercolor == "black"
                                                                                                                            ? "tableRowBlack1 "
                                                                                                                            : "" : ""}>{item.seller_dealer_id}</td>
                                                                            <td>{item.dealer_name}</td>
                                                                            <td className={item.seller_id != "" ?
                                                                                item.color == "pink"
                                                                                    ? "tableRowPink "
                                                                                    : item.color == "Silver"
                                                                                        ? "tableRowSilver "
                                                                                        : item.color == "Orange"
                                                                                            ? "tableRowOrange "
                                                                                            : item.color == "Navy blue"
                                                                                                ? "tableRowNavyBlue "
                                                                                                : item.color == "firered"
                                                                                                    ? "tableRowFireRed "
                                                                                                    : item.color == "Purple"
                                                                                                        ? "tableRowPurple "
                                                                                                        : item.color == "Yellow"
                                                                                                            ? "tableRowYellow1 "
                                                                                                            : item.color == "green"
                                                                                                                ? "tableRowGreenColor "
                                                                                                                : item.color == "blue"
                                                                                                                    ? "tableRowBlue "
                                                                                                                    : item.color == "darkred"
                                                                                                                        ? "tableRowRed1 "
                                                                                                                        : item.color == "black"
                                                                                                                            ? "tableRowBlack1 "
                                                                                                                            : "" : ""}>{item.seller_id}</td>
                                                                            <td><span className="cartitlename">{item.first_name} {item.last_name} </span></td>
                                                                            <td>{item.email == "" || item.email == null || item.email == "null" ? "" : item.email}</td>
                                                                            <td className="userImage">{item.image === "" || item.image === null ?
                                                                                <img alt="" src={adduser} /> :
                                                                                <img alt="" src={item.image} />
                                                                            }</td>
                                                                            <td className="phonenotab">{item.phone_no === null || item.phone_no === undefined || item.phone_no === "" ? "" : `${item.country_code === null || item.country_code === undefined || item.country_code == null || item.country_code == "undefined" || item.country_code == "null" ? "" : item.country_code}${formatMobileNO(item.phone_no)}`}</td>
                                                                            <td>{item.extentation == "" || item.extentation == null || item.extentation == "null" ? "" : item.extentation}</td>

                                                                            {/* <td>{item.email}</td> */}

                                                                            {/* <td>{item.create_user === 1 ? "Create User," : ""}{item.remove_car === 1 ? "Remove Car," : ""}{item.counter_bid === 1 ? "Counter Bid," : ""}{item.post_car === 1 ? "Post Car," : "No Privileges"}</td> */}
                                                                            {/* <td>{item.create_user == 1 ? "Create User,"  : item.remove_car == 1 ? "Remove Car," : item.counter_bid == 1 ? "Counter Bid,": item.post_car == 1 ? "Post Car," : "No Privileges"}</td> */}
                                                                            {/* <td>{item.create_user === 1 ? "Create User," : ""}{item.remove_car === 1 ? "Remove Car" : ""}{item.counter_bid === 1 ? "Counter Bid," : ""}{item.post_car === 0 && item.create_user === 0 && item.remove_car === 0 && item.counter_bid === 0 && item.post_car === 0? "No Privileges" : ""}</td> */}
                                                                            <td>{item.create_user === 1 ? "Create User," : ""}{item.remove_car === 1 ? "Remove Car," : ""}{item.counter_bid === 1 ? "Counter Bid," : ""}{item.post_car == 1 ? "Post Car," : ""}{item.user_list == 1 ? "User." : ""}{item.post_car === 0 && item.create_user === 0 && item.remove_car === 0 && item.counter_bid === 0 && item.post_car === 0 ? "No Privileges" : ""}</td>
                                                                            <td>{item.emailstatus}</td>
                                                                            <td>{item.ssl_no === null || item.ssl_no === undefined || item.ssl_no === "" ? "" : `${MaskedSSN(item.ssl_no)}`}</td>

                                                                            <td>{item.adminstatus === 1 ? "Active" : "Inactive"}</td>
                                                                            {/* <td><Button className="ant-btn" onClick={() => onHandleEdit(item)}><i className="icofont-ui-edit"></i> Edit</Button></td> */}
                                                                            <td className='action-right-fix-list' ><Button className="ant-btn" onClick={() => onHandleEdit(item)}> View</Button></td>

                                                                        </tr>
                                                                    ) :
                                                                        <tr><td colspan="6" ng-show="0">
                                                                            <b>There's No Data</b>
                                                                        </td>
                                                                        </tr>
                                                                    }
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 tablePagination d-flex justify-content-center pageul">
                                                            {/* <Pagination className=""
														totalRecords={totalRecords}
														pageLimit={pageLimit}
														pageRangeDisplayed={1}
														onChangePage={setCurrentPage}
													/> */}
                                                            <CustomPagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} totalRecords={totalRecords} handlePages={handlePages} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </section>
                    }



                    <section id="playstoreBlock" className="playstoreBlock">
                        <div className="container">


                            <div className="row content">
                                <div className="col-lg-12">
                                    <img src={appstore} />
                                    <img src={googleplay} />
                                </div>

                            </div>

                        </div>
                    </section>
                    {isOpen &&
                        <CommonPopup
                            handleClose={togglePopup}
                            popupTitle={popupTitle}
                            popupMsg={popupMsg}
                            popupType={popupType}
                            popupActionType={popupActionType}
                            popupActionValue={popupActionValue}
                            popupActionPath={popupActionPath}
                        />}
                </main>}
        </div>


    );
};

export default Seller;